const config = {
  BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
};
export default config;
